export default "__VITE_ASSET__BtPf2HT1__"